const SYSTEM_AGENT_STATUSES = [
  "ready", "not_ready", "offline", "ringing", "on_call", "after_call_work",
] as const;

type SystemAgentStatus = typeof SYSTEM_AGENT_STATUSES[number];

function isSystemAgentStatus(value: string): value is SystemAgentStatus {
  return SYSTEM_AGENT_STATUSES.some(status => status === value);
}

/** A login selects a fresh label; it never inherits a previous session's label. */
export function resolveAgentLoginStatus(value: string): {
  status: SystemAgentStatus;
  customLabel: string | null;
} {
  return isSystemAgentStatus(value)
    ? { status: value, customLabel: null }
    : { status: "not_ready", customLabel: value };
}

interface AgentStatusState {
  status: string;
  customLabel?: string | null;
}

/** Retained availability labels must not hide system call states in status views. */
export function getAgentStatusDisplayLabel(
  status: string,
  customLabel: string | null | undefined,
  systemLabel: string,
): string {
  return status === "not_ready" && customLabel ? customLabel : systemLabel;
}

/** Ready is a normal system mode, including when a caller omits customLabel. */
export function normalizeReadyAgentStatus<T extends Partial<AgentStatusState>>(value: T): T {
  return value.status === "ready" ? { ...value, customLabel: null } : value;
}

/** Compare saved rows, not an incomplete update request. */
export function hasSavedAgentStatusChanged(previous: AgentStatusState, saved: AgentStatusState): boolean {
  return previous.status !== saved.status ||
    (previous.customLabel ?? null) !== (saved.customLabel ?? null);
}
